export const NOOP_MODAL_PROPS = {
    onClose: () => { },
};
//# sourceMappingURL=noopModalProps.js.map